import api from './api';

export const homeService = {
  get: () => api.get('/home'),
  update: (data) => api.put('/home', data),
  updateSlider: (slides) => api.put('/home/slider', { slides }),
  updateCTA: (cta) => api.put('/home/cta', { ctaBanner: cta }),
  updateFeatured: (data) => api.put('/home/featured', data),
};